const DEFAULT_APPLICATION_1 =
{
    /*
    isOpenForPublic: true,
    isOpenForBoiling: false,
    isInvested: false,
    companyName: 'Yepzon Oy',
    id: '234-123',
    type: 'Equity',
    customerId: '',
    daysOpen: 20,
    investedRatio: 43, 
    investedAmount: 112300,
    investors: 44,
    equityOfferedMinPcnt: 13.2,
    equityOfferedMaxPcnt: 16.2,
    minAmount: 240000,
    maxAmount: 500000,
    pricePerShare: 32.4,
    minInvestmentShares: 100,
    numberOfExistingShares: 23122,
    fullyDilutedShares: 25029,
    preMoneyValuation: 12939391,
    estimatedRevenue: 1239123,
    estimatedRevenueYear: 2018,
    startDate: '2017.09.19',
    location: 'Helsinki',
    contactPerson: 'Basse Wiik',
    homePage: 'www.nordiccap.fi',
    country: 'Finland',
    sector: 'Technology',
    investmentType: 'Growth',
    cardHeaderText: 'Yepzon™ - Going number One in locating business',
    cardOverlayText: 'Going number One in locating business',
    image: 'http://kehikkoapi.azurewebsites.net/images/applications/yepzon.png',
    imageLogo: 'http://kehikkoapi.azurewebsites.net/images/applications/yepzon_small.png',
    cardText: 'Yepzon provides tech leading locating devices with a uniquely reliable, highly profitable service. This easily scalable platform already offers additional safety for thousands of people every day.',
    cardBullets: [
        {bullet: '45% average subscription base growth per quarter.'},
        {bullet: 'Three different location technologies in one provides a competitive edge.'},
        {bullet: 'Yepzon is the preferred brand by leading distributors both domestically and globally.'}
    ],
    story: `<p>Infertility is increasing in all Western countries and it affects many individual's dreams of having a child.</p> 
    For example in Finland 27% of women and 40% of men over 35 years old are childless (source: Tilastokeskus - Finnish Statistics). There are numerous reasons for voluntary and involuntary childlessness such as life style choices, environmental factors and postponing having children. Many times a specific reason cannot be determined. Over 80% of people suffering from infertility can be helped with modern treatment technologies. 
    
    Ovumia (business code 2320294-0) is a leading fertility clinic chain in North Europe and Finland's largest chain specialised in fertility treatments, whose clients have had over 12,000 babies. Ovumia performs over 70% of egg donor treatments in Finland. Of all Finnish clinics Ovumia also has the most extensive international clientele (from e.g. Sweden, Norway, Germany, Switzerland, Austria, Holland, England, Ireland, Russia, Canada and the United States).
    
    Ovumia’s pro forma turnover is estimated to be over 5 M€ during the next 12 months and the company is pursuing a turnover of over 34M€:n and operating profit of 7M€ in 2023.
    
    Ovumia operated as a service laboratory for fertility treatments during 2007-2015 and commenced private clinic operations on a larger scale in 2013 with an objective to be one of the leading European operators in its field.  With this objective in mind, Ovumia began to invest in the development of treatments and laboratory procedures for man and woman derived infertility in cooperation with Tekes (the Finnish Funding Agency for Innovation). During 2013-2017 the company has invested over 2,5M€ in the customization of infertility treatment processes as well as the development of management and patient administration methods and systems. As a result of the above mentioned development projects the company is now the technology leader in embryo selection, embryo diagnostics, egg bank technology and embryo culturing. In 2016 Ovumia reached pregnancy results in over 60% of single donated embryo transfers. At the same time the company’s customer processes have been developed to produce added value to customers and all operations are managed via self-customized electronic management and patient administration system.
    
    Ovumia purchased Fertinova Tampere (previously AVA Tampere) from Terveystalo in 2016 and integrated the clinic into Ovumia. In May 2017 Ovumia has purchased the entire Fertinova brand from Terveystalo as well as the business operations of Fertinova clinics including all equipment and personnel in Helsinki and Jyväskylä. The transaction came into effect on August 18, 2017. 
    
    By purchasing Fertinova clinics Ovumia pursues strong growth on the economic area of Helsinki as well as significant increase of international, especially Central European customers. Due to a better transportation communication, our clinic in Helsinki will be the center for Ovumia’s international customers. Furthermore, the service range in Helsinki metropolitan area will be expanded to new services, such as hysteroscopy, proactive gamete storing, preimplantation genetic diagnosis PGS, preimplantation genetic screening PGS, fertility guidance and monitoring during pregnancy.  
    
    Ovumia’s clinic in Jyväskylä will focus on cooperating with the public sector, egg bank activities and acquiring new customers from Eastern and Central Finland.
    
    With the clinic in Tampere and the new clinics in Helsinki and Jyväskylä, Ovumia will have the possibility to further increase its clientele as the national social welware and health care reform in Finland comes into effect in 2020 (source: Government of Finland, Communications Department). Please see appendix for additional information on the reform. 
    
    As a result of the integration Fertinova clinics will adopt Ovumia’s treatment and service processes and protocols as well as the operative processes and technology developed by Ovumia. Fertinova’s consumer brand shall be maintained due the fact that the previous owner has made investments for over a million euros for the brand and its consumer recogonizition. Ovumia will use both Ovumia and Fertinova brands simultaneously and will brand the clinics ‘Ovumia Fertinova Clinics’ for future operations.
    
    Ovumia has screened a wide array of new M&A targets in Europe during the past six years. The company aims at another M&A during the latter part of 2018 followed by 1-3 acquisitions in the near future with which the company’s sales would increase to 34M€. In the future Ovumia’s service processes for international customers as well as techniques and processes used in the fertility lab will be introduced to all new acquired units/clinics during and for integration purposes and service modelling. This applies especially to lab processes and techniques related to embryo screening, diagnostics and culturing, as well as egg bank operations and DNA diagnostics. Furthermore, the management and patient administration system developed by Ovumia will be integrated thus increasing the performance of any acquired unit and facilitating the integration process through Ovumia’s expertise in fertility treatments. The company also explores growth opportunities in cooperation with other industrial players.
    
    Ovumia's parent company is Estonian fertility clinic Nova Vita Kliinik AS (business code 10285009). Ovumia has two 100% owned subsidiaries (Anna Clinics Ltd, business code 2270561-8 and Oy Anna Clinic International Ltd, business code 2259532-4) that can be used as an SPV (‘special purpose vehicle’) for expansion plans of the company. 
    
    Ovumia pursues to accumulate 1,0 - 2,4M€ of funding to execute its M&A based growth plan in which customer service and laboratory methods and techniques developed by Ovumia are introduced to the new units. The company has estimated that with the help of the upcoming share issue as well as working capital and loan funding the company can execute a new M&A during the latter half of 2018 after which the funding for new acquisitions will be arranged primarily with the company’s working capital and bank loans.   
    
    Ovumia’s strategy is described below and the following links will provide more information on fertility treatments:
    <ul>
    <li>1) Modern fertility treatments (IVF, ICSI, FET) are effective. 2.10.2016 Pekka Sillanaukee, Johanna Aaltonen, Kirsi Kananen. http://ovumia.fi/en/blog-en/modern-fertility-treatments-ivf-icsi-fet-are-effective/
    </li>
    <li>
    2) A new life from deep freeze to parents’ loving arms – Pregnancies via frozen embryo transfers (FET) and egg freezing. 27.8.2016 Pekka Sillanaukee, Kirsi Kananen, Candido Tomas. http://ovumia.fi/en/blog-en/pregnancies-via-frozen-embryo-transfers-fet-and-egg-freezing
    </li>
    <li>
    3) Finnish egg bank produces excellent pregnancy results.15.8.2016 Kati Pentti, Candido Tomás, Johanna Aaltonen. http://ovumia.fi/en/blog-en/finnish-egg-bank-produces-excellent-pregnancy-results/
    </li>
    <li>
    
    4) Mitä alkiot puuhailevat öisin – Suomen ainoa embryoskooppi valvoo Ovumiassa. 10.3.2016 Sari Hakkola. http://ovumia.fi/blog/mitae-alkiot-puuhailevat-oeisin-suomen-ainoa-embryoskooppi-valvoo-ovumiassa/
    </li>
    <li>
    
    5) Ennakoiva munasolupakastus mahdollistaa joustavamman perhesuunittelun. 20.11.2016. Mirka Paavilainen. http://ovumia.fi/blog/ennakoiva-munasolupakastus-mahdollistaa-joustavamman-perhesuunnittelun/
    <ul>
    `
    */
}

const DEFAULT_APPLICATION_2 =
{
    /*
    isOpenForPublic: true,
    isOpenForBoiling: false,
    isInvested: false,
    id: '234-124',
    type: 'Equity',
    companyName: 'Tubecon Oy',
    customerId: '',
    daysOpen: 20,
    investedRatio: 12, 
    investedAmount: 12300,
    investors: 14,
    equityOfferedMinPcnt: 33.2,
    equityOfferedMaxPcnt: 56.2,
    minAmount: 220000,
    maxAmount: 440000,
    pricePerShare: 32.4,
    minInvestmentShares: 100,
    numberOfExistingShares: 23122,
    fullyDilutedShares: 25029,
    preMoneyValuation: 12939391,
    estimatedRevenue: 1239123,
    estimatedRevenueYear: 2018,
    startDate: '2017.09.19',
    location: 'Helsinki',
    contactPerson: 'Basse Wiik',
    homePage: 'www.nordiccap.fi',
    country: 'Finland',
    sector: 'Technology',
    investmentType: 'Early',
    cardHeaderText: 'Join the connected generation movement creating the future of media!',
    cardOverlayText: 'Crafting the future of media!',
    image: 'http://kehikkoapi.azurewebsites.net/images/applications/tubecon.png',
    imageLogo: 'http://kehikkoapi.azurewebsites.net/images/applications/tubecon_small.png',   
    cardText: 'Join the connected generation movement creating the future of media!',
    cardBullets: [
        {bullet: 'Building a pan-European event network and multi-platform media that reaches millennials'},
        {bullet: 'Tubecon is the largest online video event organiser in the Nordics'},
        {bullet: 'International licensing model with successful events in Finland, Sweden and Spain'}
    ]
    */
}

export const DEFAULT_APPLICATION_STATE =   {
    /*
    isFetching: false,
    applications: [
        DEFAULT_APPLICATION_1,
        DEFAULT_APPLICATION_2,
        DEFAULT_APPLICATION_1,
        DEFAULT_APPLICATION_2
    ],
    */
 };